import { Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import useTheme from '@/theme/useTheme';
import { useState } from "react";
import { t } from "i18next";
import { useTranslation } from "next-i18next";
import LazyLoadedResponsiveImage from "../LazyLoadedResponsiveImage";

interface StepProps {
    imageSrc: string;
    text: string;
  }

  interface HowItWorksProps {
    steps: StepProps[];
  }
  
  const Step: React.FC<StepProps> = ({ imageSrc, text }) => {
    return (
      <Stack sx={{ textAlign: 'center', margin: 2,  alignItems: 'center'}}>
        <LazyLoadedResponsiveImage
          sx={{  width: '150px', height:'150px', marginBottom: 2 }}
          sources={[{ srcSet: imageSrc, media: '' }]}
          src={imageSrc}
          alt={'how game works'}
        />
        <Typography variant="body1" sx={{ color: '#B1B6C6',fontSize: '14px',lineHeight:'24px',fontWeight: 500 }}>{text}</Typography>
      </Stack>
    );
  };

  const HowItWorks: React.FC<HowItWorksProps> = ({ steps }) => {
    const { theme } = useTheme();
    const [t] = useTranslation();

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Box>
            <Typography variant="body2" fontSize={14}  onClick={handleClickOpen} sx={{cursor: 'pointer', textAlign: 'center', color:theme.palette.primary.dark,}}>
                How To Play
            </Typography>
            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth > 
                <DialogContent sx={{
                    background: '#1E2329'
                }}>
                    <Stack sx={{ padding: 1, color: '#fff', }} alignItems={'center'}>
                        <Typography variant="h4" gutterBottom sx={{ textAlign: 'center', color:theme.palette.primary.dark,mb:2}}>
                            HOW TO PLAY
                        </Typography>
                        <Grid container justifyContent="center">
                            {steps.map((step, index) => (
                                <Grid item xs={12} sm={6} md={3}  key={index}>
                                <Step imageSrc={step.imageSrc} text={step.text} />
                                </Grid>
                            ))}
                        </Grid>
                        <Button 
                            onClick={handleClose}
                            variant="contained" 
                            sx={{width:'fit-content', mt:2}}>{t('OK')}
                        </Button>
                    </Stack>
                </DialogContent>
            </Dialog>
        </Box>
      
    );
  };


export default HowItWorks;
